import * as React from "react";
import { Icon } from "sb-resp-ui";
import { EventIcon } from "../EventIcon";
export const LiveStreamingIcon = (props) => {
    const isEmpty = props.showEmptyIcon || !props.hasLiveStream;
    const tooltip = isEmpty ? "" : props.tooltip;
    return (React.createElement(EventIcon, Object.assign({ isEmpty: isEmpty, hideOnMobile: false, tooltip: tooltip }, props.handler ? { onClick: props.handler } : {}), (props.hasLiveStream && !props.showEmptyIcon)
        && React.createElement(Icon, { i: `i-24-16 i-o-ev-streaming` })));
};
//# sourceMappingURL=LiveStreamingIcon.js.map